import $ from "jquery";
import ko from "knockout";
import register from "flow/knockout/register";

register.registerKnockoutBinding("returnAction", {
    init: function (element, valueAccessor, _allBindingValueAccessor, viewModel) {
        const value = ko.utils.unwrapObservable(valueAccessor());

        $(element).keydown(function (e) {
            if (e.which === 13) {
                value(viewModel);
                e.preventDefault();
            }
        });
    }
});
